import { Section } from "../survey";

export const noEmptySectionTitlesRule = (section: Readonly<Section>, _state: Record<string, any>) => {
  const emptyLanguages: string[] = [];
  
  for (const [lang, value] of Object.entries(section.title)) {
    if (value !== undefined && value.trim().length === 0) {
      emptyLanguages.push(lang);
    }
  }
  
  if (emptyLanguages.length > 0) {
    const langList = emptyLanguages.join(', ');
    return {
      passed: false,
      message: `Section has empty title for language(s): ${langList}`
    };
  }
  
  return { passed: true };
}
